(() => {
  const root = document.getElementById('AydinlatmaPopup');
  if (!root || window.vwAydinlatmaPopup) return;

  const HASH = '#aydinlatma-popup';
  const MESSAGE_TYPE = 'vw:aydinlatma-popup';
  const READY_TYPE = 'vw:aydinlatma-popup-ready';
  const CONFIG_TYPE = 'vw:aydinlatma-popup-config';
  const HULK_ORIGIN = 'https://formbuilder.hulkapps.com';
  const LOCK_CLASS = 'aydinlatma-popup-lock';
  const enabled = root.dataset.enabled !== 'false';

  const dialog = root.querySelector('.aydinlatma-popup__dialog');
  const body = root.querySelector('[data-aydinlatma-body]');
  const closeButton = root.querySelector('.aydinlatma-popup__close');
  const pageUrl = root.dataset.pageUrl;
  const loadingText = root.dataset.loading || 'Yükleniyor...';
  const errorText = root.dataset.error || 'Aydınlatma metni yüklenemedi.';

  let scrollY = 0;
  let lastFocus = null;
  let loadPromise = null;
  let loadedUrl = '';
  let scrollLockedByOther = false;

  const isOpen = () => !root.hasAttribute('hidden');

  const lockScroll = () => {
    scrollLockedByOther = document.documentElement.classList.contains('login-consent-lock');
    if (scrollLockedByOther) return;
    scrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.top = `-${scrollY}px`;
    document.documentElement.classList.add(LOCK_CLASS);
  };

  const unlockScroll = () => {
    if (scrollLockedByOther) return;
    document.documentElement.classList.remove(LOCK_CLASS);
    document.body.style.top = '';
    window.scrollTo(0, scrollY);
  };

  const setStatus = (message) => {
    body.innerHTML = '';
    const status = document.createElement('p');
    status.className = 'aydinlatma-popup__status';
    status.textContent = message;
    body.appendChild(status);
  };

  const enableCollapsibles = () => {
    if (customElements.get('at-collapsible')) return;

    const loader = document.createElement('script');
    loader.type = 'module';
    loader.textContent = "import 'components/collapsible';";
    document.head.appendChild(loader);
  };

  const popupPath = (requestedUrl) => {
    if (!requestedUrl) return pageUrl;

    try {
      const parsed = new URL(requestedUrl, window.location.href);
      if (parsed.hash === HASH) return pageUrl;
      const storePath = /^\/(pages|blogs|products|collections|policies)\//;
      if (parsed.origin === window.location.origin || storePath.test(parsed.pathname)) {
        return parsed.pathname + parsed.search;
      }
    } catch (error) {
      return pageUrl;
    }

    return pageUrl;
  };

  const loadContent = (targetUrl) => {
    if (loadPromise && loadedUrl === targetUrl) return loadPromise;

    loadedUrl = targetUrl;
    setStatus(loadingText);
    loadPromise = fetch(targetUrl, { credentials: 'same-origin' })
      .then((response) => {
        if (!response.ok) throw new Error(String(response.status));
        return response.text();
      })
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const main = doc.querySelector('#MainContent');
        if (!main) throw new Error('missing content');

        main.querySelectorAll('script, noscript, iframe, style').forEach((node) => node.remove());
        main.querySelectorAll('a[href]').forEach((link) => {
          const href = link.getAttribute('href') || '';
          if (href.charAt(0) === '#' || href.indexOf('javascript:') === 0) return;
          link.setAttribute('target', '_blank');
          link.setAttribute('rel', 'noopener noreferrer');
        });

        body.innerHTML = main.innerHTML;
        enableCollapsibles();
      })
      .catch(() => {
        loadPromise = null;
        loadedUrl = '';
        setStatus(errorText);
      });

    return loadPromise;
  };

  const sendConfig = (source) => {
    if (!source || typeof source.postMessage !== 'function') return;
    source.postMessage({ type: CONFIG_TYPE, enabled: enabled }, HULK_ORIGIN);
  };

  const open = (requestedUrl) => {
    if (!enabled) return;
    if (!isOpen()) {
      lastFocus = document.activeElement;
      root.removeAttribute('hidden');
      lockScroll();
    }
    body.scrollTop = 0;
    loadContent(popupPath(requestedUrl));
    window.setTimeout(() => closeButton.focus(), 0);
  };

  const close = () => {
    if (!isOpen()) return;
    root.setAttribute('hidden', '');
    unlockScroll();
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  };

  const hashRequested = () => {
    if (window.location.hash !== HASH) return false;
    const cleanUrl = window.location.pathname + window.location.search;
    history.replaceState(null, '', cleanUrl);
    return true;
  };

  root.addEventListener('click', (event) => {
    if (event.target.closest('[data-aydinlatma-close]')) close();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !isOpen()) return;
    event.preventDefault();
    close();
  });

  const isPolicyPath = (url) => {
    return url.hash === HASH || /\/pages\/(data-privacy|privacy-policy)|\/policies\/privacy-policy/i.test(url.pathname);
  };

  const isConsentPolicyLink = (link, url) => {
    if (!link.closest('.step2a-marketing-consent__aydinlatma')) return false;
    if (url.origin !== window.location.origin) return false;
    return isPolicyPath(url);
  };

  const isHubPolicyLink = (link, url) => {
    if (!link.closest('.jsc-account-hub')) return false;
    if (url.origin !== window.location.origin) return false;
    return isPolicyPath(url);
  };

  const markHubPrivacyRead = () => {
    document.querySelectorAll('.jsc-account-hub input[type="checkbox"]').forEach((box) => {
      const field = box.closest('.cf-field') || box.parentElement;
      const text = field ? field.textContent : '';
      if (box.dataset.hubPrivacy === 'true' || text.indexOf('Aydınlatma Metnimizden') !== -1) {
        box.dataset.policyRead = 'true';
        box.dataset.hubPrivacy = 'true';
      }
    });
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest && event.target.closest('a[href]');
    if (!link) return;

    let url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (error) {
      return;
    }

    const consentPolicy = isConsentPolicyLink(link, url);
    const hubPolicy = isHubPolicyLink(link, url);
    const hashPopup = url.origin === window.location.origin && url.hash === HASH;
    if (!consentPolicy && !hubPolicy && !hashPopup) return;
    if (!enabled) return;

    event.preventDefault();
    event.stopPropagation();

    if (consentPolicy) {
      const checkbox = document.getElementById('tm4u_aydinlatma');
      if (checkbox) checkbox.dataset.policyRead = 'true';
    }

    if (hubPolicy) markHubPrivacyRead();

    open(consentPolicy || hubPolicy ? link.href : undefined);
  }, true);

  window.addEventListener('hashchange', () => {
    if (hashRequested()) open();
  });

  window.addEventListener('message', (event) => {
    if (event.origin !== HULK_ORIGIN) return;
    const data = event.data;
    if (!data) return;

    const fromHulkFrame = Array.from(document.querySelectorAll('iframe')).some(
      (frame) => frame.contentWindow === event.source
    );
    if (!fromHulkFrame) return;

    if (data.type === READY_TYPE) {
      sendConfig(event.source);
      return;
    }

    if (data.type !== MESSAGE_TYPE || !enabled) return;
    open(data.url);
  });

  window.vwAydinlatmaPopup = { open, isOpen };

  if (hashRequested()) open();
})();
